const bentleyUniversity = {
    tagUrl: "//us2-track.inside-graph.com/gtm/IN-1000939/include.js",
    logo: "https://us2-cdn.inside-graph.com/custom/20-bu.png"
}

export default bentleyUniversity;